import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Player } from '../models/Player';
import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { CreatePlayerRequest } from '../models/createPlayerRequest';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PlayerService {

  constructor(private http:HttpClient, private configService:ConfigurationService, private authenticationService:AuthenticationService) { 
      this.baseUrl = this.configService.getApiEndpoint();
    }
  
    baseUrl:string;

    async searchPlayers(playerId:number|null):Promise<Array<Player>> {
      let endpoint = `${this.baseUrl}/players`;
      let result = await firstValueFrom(this.http.post<Player[]>(endpoint, { playerId: playerId }));
      return result;
    }

    async createPlayer(request:CreatePlayerRequest):Promise<number> {
      let endpoint = `${this.baseUrl}/player`;
      let result = await firstValueFrom(this.http.post<number>(endpoint, request));
      return result;
    }

    // Permissions are only sent from the player admin screen. Leaving them off any other
    // update means the API keeps whatever is already on the player.
    async updatePlayer(request:Player, includePermissions:boolean = false):Promise<number> {
      if(!this.authenticationService.loginResult || !this.authenticationService.loginResult.player)
        throw Error('User not authenticated.');

      let endpoint = `${this.baseUrl}/player`;
      let thisPlayerId = this.authenticationService.loginResult.player.playerId;

      let updateRequest:any = {
        updatedByPlayerId: thisPlayerId,
        firstName: request.firstName,
        lastName: request.lastName,
        email: request.email,
        phone: request.phone,
        handicapIndex: request.handicapIndex,
        id: request.id
      }

      if(includePermissions)
        updateRequest.permissions = request.permissions ?? [];

      let result = await firstValueFrom(this.http.patch<number>(endpoint, updateRequest));
      return result;
    }
}
